import React from 'react';
import styled from 'styled-components';

import { theme } from 'components';
import { formatPhoneNumber, formatPhoneNumberAsLink } from 'utils';

import { ContactDrawerTeam } from '../../../types';
import Row from '../Row';

import { Container, Section, TouchableValue } from '../common';

interface TeamContactDetailsProps {
  teamContact: ContactDrawerTeam;
}

const TeamContactDetails: React.FC<TeamContactDetailsProps> = ({
  teamContact,
}) => (
    <StyledContainer>
      <Section data-cy="contact-details-contactMethod">
        <Row label="Email">
          <TouchableValue href={`mailto:${teamContact.email}`} target="_blank">
            {teamContact.email}
          </TouchableValue>
        </Row>
        {teamContact.website && (
          <Row label="Website">
            <TouchableValue
              href={teamContact.website}
              target="_blank"
              rel="noopener"
            >
              {teamContact.website}
            </TouchableValue>
          </Row>
        )}
        {teamContact.phone && (
          <Row label="Phone">
            <TouchableValue href={formatPhoneNumberAsLink(teamContact.phone)}>
              {formatPhoneNumber(teamContact.phone)}
            </TouchableValue>
          </Row>
        )}
      </Section>
    </StyledContainer>
  );

export default TeamContactDetails;

const StyledContainer = styled(Container)`
  span {
    color: ${theme.gray8};
  }
`;
